"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2880],{

/***/ 23906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _Text__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95541);
/* harmony import */ var _utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52435);
/* eslint-disable react/jsx-props-no-spreading */ 



function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: absolute;\n  top: 0px;\n  background-color: transparent;\n  cursor: pointer;\n  transition: 0.2s;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  width: 100%;\n  position: relative;\n  background-color: ",
        ';\n  transition: 0.2s;\n\n  ::before {\n    content: "";\n    display: block;\n    position: absolute;\n    width: 0px;\n    height: 1px;\n    background-color: ',
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      ",
        "\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  background: ",
        ";\n\n  input {\n    position: inherit;\n    z-index: 1;\n    border: none;\n    background: transparent;\n  }\n\n  input::placeholder {\n    color: transparent;\n  }\n\n  input:focus {\n    outline: 0;\n  }\n\n  input:focus ~ ",
        ", input:not(:placeholder-shown) ~ ",
        " {\n    top: -20px;\n    font-size: 13px;\n  }\n\n  input:focus ~ ",
        "::before {\n    width: 100%;\n    transition: 0.5s;\n  }\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}






var Label = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_Text__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z).attrs({
    height: "28px",
    color: _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].midgray */ .Z.midgray,
    size: "16px",
    as: "label"
}).withConfig({
    componentId: "sc-c91cfec7-0"
})(_templateObject());
var Bar = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return {
        activeColorBars: props.activeColorBar
    };
}).withConfig({
    componentId: "sc-c91cfec7-1"
})(_templateObject1(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].lowgray */ .Z.lowgray, function(param) {
    var activeColorBar = param.activeColorBar;
    return activeColorBar || _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].primary */ .Z.primary;
});
var Container = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.attrs */ .ZP.div.attrs(function(props) {
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({}, (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__/* .spacingProps */ .t)(props));
}).withConfig({
    componentId: "sc-c91cfec7-2"
})(_templateObject3(), _style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, Label, Label, Bar, function(props) {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .css */ .iv)(_templateObject2(), (0,_utils_handleSpaces__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(props));
});
var InputContainer = function(_param) {
    var children = _param.children, className = _param.className, activeColorBar = _param.activeColorBar, otherProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(_param, [
        "children",
        "className",
        "activeColorBar"
    ]);
    var childrenProps = children.props;
    var placeholder = childrenProps.placeholder;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(Container, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        className: className
    }, otherProps), {
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Bar, {
                activeColorBar: activeColorBar
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(Label, {
                children: placeholder || " "
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (InputContainer);


/***/ }),

/***/ 23777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ZE": function() { return /* binding */ submitEmailLogin; },
/* harmony export */   "d2": function() { return /* binding */ submitFacebookLogin; },
/* harmony export */   "jN": function() { return /* binding */ formatErrorMessage; },
/* harmony export */   "oq": function() { return /* binding */ sendClevertapEvent; },
/* harmony export */   "wd": function() { return /* binding */ submitGoogleLogin; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82670);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48028);
/* harmony import */ var lib_api_authNext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39762);





var sendClevertapEvent = {
    loginMethod: function(method) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .clevertapEvent */ .Lq)("Login Selected", {
            "Login Method": method
        });
    },
    loginSuccess: function(method) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .clevertapEvent */ .Lq)("Login Successful", {
            "Login Method": method
        });
    },
    loginFailed: function(method, message) {
        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_1__/* .clevertapEvent */ .Lq)("Login Failed", {
            "Login Method": method,
            Message: message
        });
    }
};
var submitEmailLogin = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var username, password, verificationToken, recaptchaVersion, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    username = param.username, password = param.password, verificationToken = param.verificationToken, recaptchaVersion = param.recaptchaVersion;
                    if (!(!username || !password)) {
                        _ctx.next = 3;
                        break;
                    }
                    throw new Error("Username and password are required");
                case 3:
                    _ctx.next = 5;
                    return (0,lib_api_authNext__WEBPACK_IMPORTED_MODULE_2__/* .emailLogin */ .ZA)({
                        username: username,
                        password: password,
                        verificationToken: verificationToken,
                        recaptchaVersion: recaptchaVersion
                    });
                case 5:
                    data = _ctx.sent.data;
                    if (data) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Could not perform submit");
                case 8:
                    return _ctx.abrupt("return", data);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function submitEmailLogin(_) {
        return _ref.apply(this, arguments);
    };
}();
var submitFacebookLogin = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var accountId, accessToken, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    accountId = param.accountId, accessToken = param.accessToken;
                    if (!(!accountId || !accessToken)) {
                        _ctx.next = 3;
                        break;
                    }
                    throw new Error("Account ID and access token are required");
                case 3:
                    _ctx.next = 5;
                    return (0,lib_api_authNext__WEBPACK_IMPORTED_MODULE_2__/* .fbLogin */ .YT)({
                        id: accountId,
                        key: accessToken
                    });
                case 5:
                    data = _ctx.sent.data;
                    if (data) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Could not perform submit");
                case 8:
                    return _ctx.abrupt("return", data);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function submitFacebookLogin(_) {
        return _ref.apply(this, arguments);
    };
}();
var submitGoogleLogin = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
        var accountId, accessToken, data;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    accountId = param.accountId, accessToken = param.accessToken;
                    if (!(!accountId || !accessToken)) {
                        _ctx.next = 3;
                        break;
                    }
                    throw new Error("Account ID and access token are required");
                case 3:
                    _ctx.next = 5;
                    return (0,lib_api_authNext__WEBPACK_IMPORTED_MODULE_2__/* .googleLogin */ .u9)({
                        id: accountId,
                        key: accessToken
                    });
                case 5:
                    data = _ctx.sent.data;
                    if (data) {
                        _ctx.next = 8;
                        break;
                    }
                    throw new Error("Could not perform submit");
                case 8:
                    return _ctx.abrupt("return", data);
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function submitGoogleLogin(_) {
        return _ref.apply(this, arguments);
    };
}();
var formatErrorMessage = function(error) {
    var ref, ref1;
    var message = "";
    var errorResponse = error;
    var errorMessage = errorResponse === null || errorResponse === void 0 ? void 0 : (ref = errorResponse.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
    if (errorMessage) {
        message = errorMessage;
    } else if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(error, Error)) {
        message = error.message;
    }
    return message;
};


/***/ }),

/***/ 80139:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BT": function() { return /* binding */ useLoginGoogleMutation; },
/* harmony export */   "HW": function() { return /* binding */ useLoginFacebookMutation; },
/* harmony export */   "e1": function() { return /* binding */ useLoginEmailMutation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(26042);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2497);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(48228);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(61608);
/* harmony import */ var utils_auth__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19225);
/* harmony import */ var config_refreshToken_exodus__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14350);
/* harmony import */ var lib_entities_credentials__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21671);
/* harmony import */ var global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(25516);
/* harmony import */ var lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79644);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(48028);
/* harmony import */ var features_register_constants__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28456);
/* harmony import */ var utils_logger__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(91635);
/* harmony import */ var features_trusted_device_store__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(91164);
/* harmony import */ var features_trusted_device_utils__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(721);
/* harmony import */ var features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(33597);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(23777);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(99055);
/* harmony import */ var _store__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(8340);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(16727);






















var mapingResponseDataLogin = function(respData) {
    var ref, ref1;
    var data = {
        user: (respData === null || respData === void 0 ? void 0 : respData.user) || null,
        access: (respData === null || respData === void 0 ? void 0 : (ref = respData.token_data) === null || ref === void 0 ? void 0 : ref.access) || null,
        refresh: (respData === null || respData === void 0 ? void 0 : (ref1 = respData.token_data) === null || ref1 === void 0 ? void 0 : ref1.refresh) || null,
        onesignal_hash: (respData === null || respData === void 0 ? void 0 : respData.onesignal_hash) || null,
        support: (respData === null || respData === void 0 ? void 0 : respData.support) || null
    };
    return data;
};
function handleSuccess(data, loginType) {
    return _handleSuccess.apply(this, arguments);
}
function _handleSuccess() {
    _handleSuccess = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(data, loginType) {
        var _user, userId, username, email, avatar, responseVerified, isEmitenUser, support;
        return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _helpers__WEBPACK_IMPORTED_MODULE_15__/* .sendClevertapEvent.loginSuccess */ .oq.loginSuccess(loginType);
                    _user = data.user, userId = _user.id, username = _user.username, email = _user.email, avatar = _user.avatar;
                    _ctx.next = 4;
                    return lib_api_verifiedBadge__WEBPACK_IMPORTED_MODULE_8__/* ["default"].getVerifiedBadgeUser */ .Z.getVerifiedBadgeUser(userId);
                case 4:
                    responseVerified = _ctx.sent;
                    if (responseVerified === null || responseVerified === void 0 ? void 0 : responseVerified.data) {
                        isEmitenUser = responseVerified.data.is_emitten || false;
                        // Track if username is empty
                        if (!username) {
                            (0,utils_logger__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(new Error("[CT initialization Error]: username is empty"), {
                                place: "src/features/login/hooks/useLoginMutation.ts",
                                event: "validatePhoneOtp",
                                eventParam: {
                                    profile: data.user
                                }
                            });
                        }
                        // @ts-ignore
                        (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_9__/* .clevertapProfilingUser */ .$b)({
                            email: email,
                            identity: username,
                            isEmitenUser: isEmitenUser,
                            isInitProfile: true,
                            profilePictureUrl: avatar
                        });
                    }
                    localStorage.setItem(_constants__WEBPACK_IMPORTED_MODULE_19__/* .IS_LOGGED_IN_LOCALSTORAGE */ .J4, "true");
                    support = data.support;
                    if (support) {
                        utils_auth__WEBPACK_IMPORTED_MODULE_4__/* ["default"].setLocalCrispSettings */ .Z.setLocalCrispSettings((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)({}, support));
                    }
                case 9:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _handleSuccess.apply(this, arguments);
}
function handleError(loginType, errorMessage) {
    _helpers__WEBPACK_IMPORTED_MODULE_15__/* .sendClevertapEvent.loginFailed */ .oq.loginFailed(loginType, errorMessage);
}
function useLoginEmailMutation() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref = (0,_store__WEBPACK_IMPORTED_MODULE_17__/* .useLoginAction */ .Hd)(), stopLoading = ref.stopLoading, setError = ref.setError, setEmailLoginProps = ref.setEmailLoginProps;
    var ref1 = (0,features_trusted_device_store__WEBPACK_IMPORTED_MODULE_12__/* .useTrustedDeviceStore */ .u)(function(s) {
        return {
            updateLoginType: s.updateLoginType,
            updateNewDeviceOTPConfig: s.updateNewDeviceOTPConfig,
            updateTrustedDevice: s.updateTrustedDevice
        };
    }), updateLoginType = ref1.updateLoginType, updateNewDeviceOTPConfig = ref1.updateNewDeviceOTPConfig, updateTrustedDevice = ref1.updateTrustedDevice;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_21__/* .useMutation */ .D)({
        mutationFn: _helpers__WEBPACK_IMPORTED_MODULE_15__/* .submitEmailLogin */ .ZE,
        onSuccess: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
                var respData, data, ref, ref1, ref2, ref3;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            respData = param.data;
                            data = mapingResponseDataLogin((respData === null || respData === void 0 ? void 0 : respData.login) || {});
                            stopLoading();
                            if ((respData === null || respData === void 0 ? void 0 : respData.type) === _types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_NEW_DEVICE */ .B.LOGIN_DATA_TYPE_NEW_DEVICE) {
                                ;
                                updateLoginType(_types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_NEW_DEVICE */ .B.LOGIN_DATA_TYPE_NEW_DEVICE);
                                updateNewDeviceOTPConfig({
                                    token: respData === null || respData === void 0 ? void 0 : (ref = respData.new_device) === null || ref === void 0 ? void 0 : ref.token,
                                    otpRecipients: (0,features_trusted_device_utils__WEBPACK_IMPORTED_MODULE_13__/* .mapOtpOptions */ .g)(respData === null || respData === void 0 ? void 0 : (ref1 = respData.new_device) === null || ref1 === void 0 ? void 0 : ref1.otp_recipients)
                                });
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerLoginAttempt */ .SU)();
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerOtpVerified */ .U0)();
                                router.push("/trusted-device/otp");
                            }
                            if ((respData === null || respData === void 0 ? void 0 : respData.type) === _types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_TRUSTED_DEVICE */ .B.LOGIN_DATA_TYPE_TRUSTED_DEVICE) {
                                ;
                                updateLoginType(_types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_TRUSTED_DEVICE */ .B.LOGIN_DATA_TYPE_TRUSTED_DEVICE);
                                updateTrustedDevice({
                                    token: respData === null || respData === void 0 ? void 0 : (ref2 = respData.trusted_device) === null || ref2 === void 0 ? void 0 : ref2.token,
                                    deviceName: respData === null || respData === void 0 ? void 0 : (ref3 = respData.trusted_device) === null || ref3 === void 0 ? void 0 : ref3.device_name
                                });
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerLoginAttempt */ .SU)();
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerPromptSent */ .Z3)();
                                router.push("/trusted-device/prompt");
                            }
                            if ((respData === null || respData === void 0 ? void 0 : respData.type) === _types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_SUCCESS */ .B.LOGIN_DATA_TYPE_SUCCESS) {
                                updateLoginType(_types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_SUCCESS */ .B.LOGIN_DATA_TYPE_SUCCESS);
                                // @ts-ignore
                                dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_6__/* ["default"].actions.loadCredentialsExodus */ .ZP.actions.loadCredentialsExodus(data));
                                handleSuccess(data, features_register_constants__WEBPACK_IMPORTED_MODULE_10__/* .registerTypes.EMAIL */ .E8.EMAIL);
                                (0,config_refreshToken_exodus__WEBPACK_IMPORTED_MODULE_5__/* .getRefreshTokenConfigFn */ .oD)(true);
                                // reset local store
                                setEmailLoginProps({
                                    username: "",
                                    password: ""
                                });
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerLoginCompleted */ .pO)();
                                router.push("/stream");
                            }
                            return _ctx.abrupt("return", Promise.resolve(data));
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error) {
            var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
            var errorMessage = (0,_helpers__WEBPACK_IMPORTED_MODULE_15__/* .formatErrorMessage */ .jN)(error);
            var error503 = ((ref = error) === null || ref === void 0 ? void 0 : (ref1 = ref.response) === null || ref1 === void 0 ? void 0 : ref1.status) === 503;
            if (((ref2 = error) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.response) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.data) === null || ref4 === void 0 ? void 0 : ref4.error_type) === constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].INVALID_RECAPTCHA */ .Z.INVALID_RECAPTCHA) {
                router.push("/login/verification");
                return Promise.reject(errorMessage);
            }
            if (((ref5 = error) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.response) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.data) === null || ref7 === void 0 ? void 0 : ref7.error_type) === constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].INVALID_PARAMETER */ .Z.INVALID_PARAMETER) {
                router.push("/login");
                return Promise.reject(errorMessage);
            }
            if (errorMessage) {
                handleError(features_register_constants__WEBPACK_IMPORTED_MODULE_10__/* .registerTypes.EMAIL */ .E8.EMAIL, errorMessage);
                setError(errorMessage);
            }
            if (errorMessage && !error503) {
                (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(errorMessage, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
            }
            stopLoading();
            return Promise.reject(errorMessage);
        }
    });
}
function useLoginFacebookMutation() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var stopLoading = (0,_store__WEBPACK_IMPORTED_MODULE_17__/* .useLoginAction */ .Hd)().stopLoading;
    var ref = (0,features_trusted_device_store__WEBPACK_IMPORTED_MODULE_12__/* .useTrustedDeviceStore */ .u)(function(s) {
        return {
            updateLoginType: s.updateLoginType,
            updateNewDeviceOTPConfig: s.updateNewDeviceOTPConfig,
            updateTrustedDevice: s.updateTrustedDevice
        };
    }), updateLoginType = ref.updateLoginType, updateNewDeviceOTPConfig = ref.updateNewDeviceOTPConfig, updateTrustedDevice = ref.updateTrustedDevice;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_21__/* .useMutation */ .D)({
        mutationFn: _helpers__WEBPACK_IMPORTED_MODULE_15__/* .submitFacebookLogin */ .d2,
        onSuccess: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
                var respData, data, ref, ref1, ref2, ref3;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            respData = param.data;
                            data = mapingResponseDataLogin((respData === null || respData === void 0 ? void 0 : respData.login) || {});
                            stopLoading();
                            if ((respData === null || respData === void 0 ? void 0 : respData.type) === _types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_NEW_DEVICE */ .B.LOGIN_DATA_TYPE_NEW_DEVICE) {
                                ;
                                updateLoginType(_types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_NEW_DEVICE */ .B.LOGIN_DATA_TYPE_NEW_DEVICE);
                                updateNewDeviceOTPConfig({
                                    token: respData === null || respData === void 0 ? void 0 : (ref = respData.new_device) === null || ref === void 0 ? void 0 : ref.token,
                                    otpRecipients: (0,features_trusted_device_utils__WEBPACK_IMPORTED_MODULE_13__/* .mapOtpOptions */ .g)(respData === null || respData === void 0 ? void 0 : (ref1 = respData.new_device) === null || ref1 === void 0 ? void 0 : ref1.otp_recipients)
                                });
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerLoginAttempt */ .SU)();
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerOtpVerified */ .U0)();
                                router.push("/trusted-device/otp");
                            }
                            if ((respData === null || respData === void 0 ? void 0 : respData.type) === _types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_TRUSTED_DEVICE */ .B.LOGIN_DATA_TYPE_TRUSTED_DEVICE) {
                                ;
                                updateLoginType(_types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_TRUSTED_DEVICE */ .B.LOGIN_DATA_TYPE_TRUSTED_DEVICE);
                                updateTrustedDevice({
                                    token: respData === null || respData === void 0 ? void 0 : (ref2 = respData.trusted_device) === null || ref2 === void 0 ? void 0 : ref2.token,
                                    deviceName: respData === null || respData === void 0 ? void 0 : (ref3 = respData.trusted_device) === null || ref3 === void 0 ? void 0 : ref3.device_name
                                });
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerLoginAttempt */ .SU)();
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerPromptSent */ .Z3)();
                                router.push("/trusted-device/prompt");
                            }
                            if ((respData === null || respData === void 0 ? void 0 : respData.type) === _types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_SUCCESS */ .B.LOGIN_DATA_TYPE_SUCCESS) {
                                updateLoginType(_types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_SUCCESS */ .B.LOGIN_DATA_TYPE_SUCCESS);
                                // @ts-ignore
                                dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_6__/* ["default"].actions.loadCredentialsExodus */ .ZP.actions.loadCredentialsExodus(data));
                                handleSuccess(data, features_register_constants__WEBPACK_IMPORTED_MODULE_10__/* .registerTypes.FACEBOOK */ .E8.FACEBOOK);
                                (0,config_refreshToken_exodus__WEBPACK_IMPORTED_MODULE_5__/* .getRefreshTokenConfigFn */ .oD)(true);
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerLoginCompleted */ .pO)();
                                router.push("/stream");
                            }
                            return _ctx.abrupt("return", Promise.resolve(data));
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error, param) {
            var resolveLoginErrorCallback = param.resolveLoginErrorCallback;
            var errorMessage = (0,_helpers__WEBPACK_IMPORTED_MODULE_15__/* .formatErrorMessage */ .jN)(error);
            if (errorMessage) {
                handleError(features_register_constants__WEBPACK_IMPORTED_MODULE_10__/* .registerTypes.FACEBOOK */ .E8.FACEBOOK, errorMessage);
                (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(errorMessage, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
            }
            if (resolveLoginErrorCallback) resolveLoginErrorCallback();
            stopLoading();
            return Promise.reject(errorMessage);
        }
    });
}
function useLoginGoogleMutation() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var stopLoading = (0,_store__WEBPACK_IMPORTED_MODULE_17__/* .useLoginAction */ .Hd)().stopLoading;
    var ref = (0,features_trusted_device_store__WEBPACK_IMPORTED_MODULE_12__/* .useTrustedDeviceStore */ .u)(function(s) {
        return {
            updateLoginType: s.updateLoginType,
            updateNewDeviceOTPConfig: s.updateNewDeviceOTPConfig,
            updateTrustedDevice: s.updateTrustedDevice
        };
    }), updateLoginType = ref.updateLoginType, updateNewDeviceOTPConfig = ref.updateNewDeviceOTPConfig, updateTrustedDevice = ref.updateTrustedDevice;
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_21__/* .useMutation */ .D)({
        mutationFn: _helpers__WEBPACK_IMPORTED_MODULE_15__/* .submitGoogleLogin */ .wd,
        onSuccess: function() {
            var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(param) {
                var respData, data, ref, ref1, ref2, ref3;
                return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            respData = param.data;
                            data = mapingResponseDataLogin((respData === null || respData === void 0 ? void 0 : respData.login) || {});
                            stopLoading();
                            if ((respData === null || respData === void 0 ? void 0 : respData.type) === _types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_NEW_DEVICE */ .B.LOGIN_DATA_TYPE_NEW_DEVICE) {
                                ;
                                updateLoginType(_types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_NEW_DEVICE */ .B.LOGIN_DATA_TYPE_NEW_DEVICE);
                                updateNewDeviceOTPConfig({
                                    token: respData === null || respData === void 0 ? void 0 : (ref = respData.new_device) === null || ref === void 0 ? void 0 : ref.token,
                                    otpRecipients: (0,features_trusted_device_utils__WEBPACK_IMPORTED_MODULE_13__/* .mapOtpOptions */ .g)(respData === null || respData === void 0 ? void 0 : (ref1 = respData.new_device) === null || ref1 === void 0 ? void 0 : ref1.otp_recipients)
                                });
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerLoginAttempt */ .SU)();
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerOtpVerified */ .U0)();
                                router.push("/trusted-device/otp");
                            }
                            if ((respData === null || respData === void 0 ? void 0 : respData.type) === _types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_TRUSTED_DEVICE */ .B.LOGIN_DATA_TYPE_TRUSTED_DEVICE) {
                                ;
                                updateLoginType(_types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_TRUSTED_DEVICE */ .B.LOGIN_DATA_TYPE_TRUSTED_DEVICE);
                                updateTrustedDevice({
                                    token: respData === null || respData === void 0 ? void 0 : (ref2 = respData.trusted_device) === null || ref2 === void 0 ? void 0 : ref2.token,
                                    deviceName: respData === null || respData === void 0 ? void 0 : (ref3 = respData.trusted_device) === null || ref3 === void 0 ? void 0 : ref3.device_name
                                });
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerLoginAttempt */ .SU)();
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerPromptSent */ .Z3)();
                                router.push("/trusted-device/prompt");
                            }
                            if ((respData === null || respData === void 0 ? void 0 : respData.type) === _types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_SUCCESS */ .B.LOGIN_DATA_TYPE_SUCCESS) {
                                updateLoginType(_types__WEBPACK_IMPORTED_MODULE_16__/* .LoginType.LOGIN_DATA_TYPE_SUCCESS */ .B.LOGIN_DATA_TYPE_SUCCESS);
                                // @ts-ignore
                                dispatch(lib_entities_credentials__WEBPACK_IMPORTED_MODULE_6__/* ["default"].actions.loadCredentialsExodus */ .ZP.actions.loadCredentialsExodus(data));
                                handleSuccess(data, features_register_constants__WEBPACK_IMPORTED_MODULE_10__/* .registerTypes.GOOGLE */ .E8.GOOGLE);
                                (0,config_refreshToken_exodus__WEBPACK_IMPORTED_MODULE_5__/* .getRefreshTokenConfigFn */ .oD)(true);
                                (0,features_trusted_device_tracker__WEBPACK_IMPORTED_MODULE_14__/* .trackerLoginCompleted */ .pO)();
                                router.push("/stream");
                            }
                            return _ctx.abrupt("return", Promise.resolve(data));
                        case 7:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(_) {
                return _ref.apply(this, arguments);
            };
        }(),
        onError: function(error, param) {
            var resolveLoginErrorCallback = param.resolveLoginErrorCallback;
            var errorMessage = (0,_helpers__WEBPACK_IMPORTED_MODULE_15__/* .formatErrorMessage */ .jN)(error);
            if (errorMessage) {
                handleError(features_register_constants__WEBPACK_IMPORTED_MODULE_10__/* .registerTypes.GOOGLE */ .E8.GOOGLE, errorMessage);
                (0,global_AlertErrorMessage__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(errorMessage, constants_errorMessage__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ALERT_RED */ .Z.ALERT_RED);
            }
            if (resolveLoginErrorCallback) resolveLoginErrorCallback();
            return Promise.reject(errorMessage);
        }
    });
}



/***/ }),

/***/ 2880:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ login; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/global/AuthCardLayout/index.tsx + 1 modules
var AuthCardLayout = __webpack_require__(33406);
// EXTERNAL MODULE: ./src/global/AuthCardLayout/Divider.tsx
var Divider = __webpack_require__(27253);
// EXTERNAL MODULE: ./src/global/QueryProvider/index.tsx
var QueryProvider = __webpack_require__(62780);
// EXTERNAL MODULE: ./src/global/Loading/SecondarySpinner.tsx
var SecondarySpinner = __webpack_require__(32447);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Button.js
var Button = __webpack_require__(20539);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/features/register/constants.ts
var constants = __webpack_require__(28456);
// EXTERNAL MODULE: ./src/global/Securities/stores/useSecuritiesCredentialStore.ts + 1 modules
var useSecuritiesCredentialStore = __webpack_require__(71158);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(50259);
// EXTERNAL MODULE: ./src/features/login/styled.ts
var styled = __webpack_require__(30928);
// EXTERNAL MODULE: ./src/features/login/store.ts
var store = __webpack_require__(8340);
// EXTERNAL MODULE: ./src/features/login/helpers.ts
var helpers = __webpack_require__(23777);
// EXTERNAL MODULE: ./src/features/login/hooks/useLoginMutation.ts
var useLoginMutation = __webpack_require__(80139);
;// CONCATENATED MODULE: ./src/features/login/__tests__/constants.ts
var TEST_CASE_LOGIN_COMPONENTS = function(comp) {
    return {
        SHOULD_RENDER_SUCCESSFULLY: "Component ".concat(comp, " in Login Feature should render successfully")
    };
};
var DATA_CY_LOGIN_COMPONENTS = {
    LOGIN_FORGOT_PW_LINK: "auth-card-forgot-pw-link",
    LOGIN_LAYOUT: "auth-card-layout",
    LOGIN_SIGNUP_LINK: "auth-card-register-link",
    LOGIN_TERMS_LINK: "auth-card-terms-link",
    LOGIN_SPINNER: "global-loading-spinner-container",
    LOGIN_ALERT: "global-alert-message",
    LOGIN_FORM: "login-form",
    LOGIN_FORM_USERNAME: "login-form-username",
    LOGIN_FORM_USERNAME_ICON: "login-form-username-icon",
    LOGIN_FORM_PW: "login-form-pw",
    LOGIN_FORM_PW_SHOW: "login-form-show-pw",
    LOGIN_FORM_SUBMIT: "login-form-submit",
    LOGIN_FORM_BUTTON_GOOGLE: "login-form-button-facebook",
    LOGIN_FORM_BUTTON_FACEBOOK: "login-form-button-google"
};

;// CONCATENATED MODULE: ./src/features/login/EmailLogin/index.tsx


















function EmailLogin() {
    var buttonEl = (0,react.useRef)(null);
    var loginMutation = (0,useLoginMutation/* useLoginEmailMutation */.e1)();
    var isLoading = (0,store/* useLoginState */.Ty)().isLoading;
    var ref = (0,store/* useLoginAction */.Hd)(), startLoading = ref.startLoading, setEmailLoginProps = ref.setEmailLoginProps;
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var ref1 = (0,react.useState)(false), showIcon = ref1[0], setShowIcon = ref1[1];
    var ref2 = (0,react.useState)(false), showPassword = ref2[0], setShowPassword = ref2[1];
    var ref3 = (0,react.useState)(""), username = ref3[0], setUsername = ref3[1];
    var onFormSubmit = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(event) {
            var elements, verificationToken2;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        startLoading();
                        useSecuritiesCredentialStore/* default.getState */.Z.getState().loadLogout();
                        helpers/* sendClevertapEvent.loginMethod */.oq.loginMethod(constants/* registerTypes.EMAIL */.E8.EMAIL);
                        elements = event.currentTarget.elements;
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return executeRecaptcha("login_browser");
                    case 8:
                        verificationToken2 = _ctx.sent;
                        _ctx.next = 11;
                        return loginMutation.mutateAsync({
                            username: elements.username.value,
                            password: elements.password.value,
                            verificationToken: verificationToken2,
                            recaptchaVersion: "RECAPTCHA_VERSION_3"
                        });
                    case 11:
                        _ctx.next = 17;
                        break;
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](5);
                        // Proceed username and password to robot verification
                        setEmailLoginProps({
                            username: elements.username.value,
                            password: elements.password.value
                        });
                        ;
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    13
                ]
            ]);
        }));
        return function onFormSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var updateShowPassword = function() {
        setShowPassword(function(prevShowPassword) {
            return !prevShowPassword;
        });
    };
    (0,react.useEffect)(function() {
        var storedEmail = localStorage.getItem(constants/* LS_EMAIL_REGISTER */.hb);
        var storedPhone = localStorage.getItem(constants/* LS_PHONE_REGISTER */.b_);
        if (storedEmail) {
            setUsername(storedEmail);
            setShowIcon(true);
        }
        if (storedPhone) {
            setShowIcon(true);
        }
        return function() {
            localStorage.removeItem(constants/* LS_EMAIL_REGISTER */.hb);
            localStorage.removeItem(constants/* LS_PHONE_REGISTER */.b_);
        };
    }, []);
    (0,react.useEffect)(function() {
        if (buttonEl === null || buttonEl === void 0 ? void 0 : buttonEl.current) {
            buttonEl.current.setAttribute("type", "submit");
        }
    }, [
        buttonEl
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
        onSubmit: onFormSubmit,
        "data-cy": DATA_CY_LOGIN_COMPONENTS.LOGIN_FORM,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* EmailContainer */.fK, {
                showIcon: showIcon,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* InputContainer */.fv, {
                        mt: "5px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Input */.II, {
                            disabled: isLoading,
                            id: "username",
                            onChange: function(e) {
                                return setUsername(e.target.value);
                            },
                            placeholder: "Email or username",
                            type: "text",
                            value: username,
                            "data-cy": DATA_CY_LOGIN_COMPONENTS.LOGIN_FORM_USERNAME,
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                        condition: showIcon,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            "data-cy": DATA_CY_LOGIN_COMPONENTS.LOGIN_FORM_USERNAME_ICON,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                src: "/icon/register/input-success.svg",
                                alt: ""
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* PasswordContainer */.on, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* InputContainer */.fv, {
                        mt: "28px",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* Input */.II, {
                            disabled: isLoading,
                            id: "password",
                            name: "password",
                            placeholder: "Password",
                            type: showPassword ? "text" : "password",
                            "data-cy": DATA_CY_LOGIN_COMPONENTS.LOGIN_FORM_PW,
                            required: true
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: updateShowPassword,
                        type: "button",
                        "data-cy": DATA_CY_LOGIN_COMPONENTS.LOGIN_FORM_PW_SHOW,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                            src: !showPassword ? "/icon/register/icon-show.svg" : "/icon/register/icon-hide.svg",
                            alt: ""
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                pt: "10px",
                color: color/* default.black */.Z.black,
                size: "12px",
                children: [
                    "Forgot your password?",
                    " ",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: "/forgotpassword",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            as: "a",
                            size: "13px",
                            "data-cy": DATA_CY_LOGIN_COMPONENTS.LOGIN_FORGOT_PW_LINK,
                            children: "Click here"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                height: "44px",
                id: "email-login-button",
                loading: isLoading,
                // @ts-expect-error
                mt: "24px",
                ref: buttonEl,
                type: "primary",
                "data-cy": DATA_CY_LOGIN_COMPONENTS.LOGIN_FORM_SUBMIT,
                block: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    family: "bold",
                    color: color/* default.light */.Z.light,
                    children: isLoading ? "Logging In . . . " : "Login"
                })
            })
        ]
    });
}
/* harmony default export */ var login_EmailLogin = (EmailLogin);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@greatsumini/react-facebook-login/dist/index.js
var dist = __webpack_require__(73502);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ./src/features/register/AuthButton/index.tsx
var AuthButton = __webpack_require__(73442);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 17 modules
var es = __webpack_require__(2497);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./src/lib/api/auth.js
var auth = __webpack_require__(6242);
// EXTERNAL MODULE: ./src/utils/generateUsername.js
var generateUsername = __webpack_require__(49431);
// EXTERNAL MODULE: ./src/features/register/slice.ts + 1 modules
var slice = __webpack_require__(9260);
;// CONCATENATED MODULE: ./src/features/login/hooks/useErrorHandler.ts











var useErrorHandler = function() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var errorHandler = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(param) {
            var accountid, accountkey, email, fullname, type, account, data, username, dataAccount, ref, username1, dataAccount1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        accountid = param.accountid, accountkey = param.accountkey, email = param.email, fullname = param.fullname, type = param.type;
                        account = {
                            accountid: accountid,
                            accountkey: accountkey,
                            email: email,
                            fullname: fullname,
                            type: type
                        };
                        _ctx.prev = 2;
                        _ctx.next = 5;
                        return auth/* default.validateSocialMedia */.Z.validateSocialMedia(accountid, accountkey, email, constants/* mappingNewRegisterTypes */.Io[type]);
                    case 5:
                        data = _ctx.sent.data;
                        username = generateUsername/* default.normalUsername */.Z.normalUsername(fullname);
                        _ctx.next = 9;
                        return auth/* default.validateRegisterForm */.Z.validateRegisterForm("username", username, data.data.key).catch(function() {
                            username = generateUsername/* default.randomUsername */.Z.randomUsername(fullname);
                        });
                    case 9:
                        dataAccount = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, account), {
                            username: username
                        });
                        dispatch(slice/* default.actions.storeEmailVerifData */.ZP.actions.storeEmailVerifData({
                            tempKey: data.data.key,
                            emailStatus: data.data.status
                        }));
                        dispatch(slice/* default.actions.storeSocialIdentities */.ZP.actions.storeSocialIdentities(dataAccount));
                        dispatch(slice/* default.actions.changeForm */.ZP.actions.changeForm({
                            target: constants/* formTypes.EMAIL */.o_.EMAIL
                        }));
                        router.push("/register");
                        _ctx.next = 24;
                        break;
                    case 16:
                        _ctx.prev = 16;
                        _ctx.t0 = _ctx["catch"](2);
                        ;
                        username1 = generateUsername/* default.randomUsername */.Z.randomUsername(fullname);
                        dataAccount1 = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, account), {
                            username: username1,
                            type: constants/* mappingNewRegisterTypes */.Io[type],
                            error: _ctx.t0 === null || _ctx.t0 === void 0 ? void 0 : (ref = _ctx.t0.cause) === null || ref === void 0 ? void 0 : ref.message
                        });
                        dispatch(slice/* default.actions.storeSocialIdentities */.ZP.actions.storeSocialIdentities(dataAccount1));
                        dispatch(slice/* default.actions.changeForm */.ZP.actions.changeForm({
                            target: constants/* formTypes.EMAIL */.o_.EMAIL
                        }));
                        router.push("/register");
                    case 24:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    16
                ]
            ]);
        }));
        return function(_) {
            return _ref.apply(this, arguments);
        };
    }(), [
        dispatch,
        router
    ]);
    return {
        errorHandler: errorHandler
    };
};
/* harmony default export */ var hooks_useErrorHandler = (useErrorHandler);

;// CONCATENATED MODULE: ./src/features/login/FacebookOauth/index.tsx












var fbAppId = "247631672013136";
function FacebookOauth() {
    var loginMutation = (0,useLoginMutation/* useLoginFacebookMutation */.HW)();
    var errorHandler = hooks_useErrorHandler().errorHandler;
    var isLoading = (0,store/* useLoginState */.Ty)().isLoading;
    var ref = (0,store/* useLoginAction */.Hd)(), startLoading = ref.startLoading, setError = ref.setError;
    var handleCallback = {
        accessToken: "",
        success: function(profile) {
            if (profile.accessToken) {
                handleCallback.accessToken = profile.accessToken;
            }
        },
        profileSuccess: function(profile) {
            if (!profile) return;
            startLoading();
            var id = profile.id, email = profile.email, name = profile.name;
            var accessToken = handleCallback.accessToken;
            if (accessToken !== "") {
                var params = {
                    accountId: id,
                    accessToken: accessToken
                };
                loginMutation.mutate((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                    resolveLoginErrorCallback: function() {
                        return errorHandler({
                            accountid: id,
                            accountkey: accessToken,
                            email: email,
                            fullname: name,
                            type: constants/* registerTypes.FACEBOOK */.E8.FACEBOOK
                        });
                    }
                }));
            }
        },
        error: function(err) {
            setError(err.status);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((dist_default()), {
        appId: fbAppId,
        fields: "name,email,picture",
        onSuccess: handleCallback.success,
        onProfileSuccess: handleCallback.profileSuccess,
        onFail: handleCallback.error,
        initParams: {
            version: "v16.0",
            xfbml: true
        },
        render: function(param) {
            var onClick = param.onClick;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: function() {
                    helpers/* sendClevertapEvent.loginMethod */.oq.loginMethod(constants/* registerTypes.FACEBOOK */.E8.FACEBOOK);
                    onClick();
                },
                type: "facebook",
                height: "44px",
                block: true,
                loading: isLoading,
                id: "facebook-login-button",
                "data-cy": DATA_CY_LOGIN_COMPONENTS.LOGIN_FORM_BUTTON_FACEBOOK,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthButton/* default */.Z, {
                    iconUrl: "/icon/register/icon-facebook.svg",
                    text: "Login with Facebook"
                })
            });
        }
    });
}
/* harmony default export */ var login_FacebookOauth = (FacebookOauth);

// EXTERNAL MODULE: ./node_modules/react-google-login/dist/google-login.js
var google_login = __webpack_require__(93645);
var google_login_default = /*#__PURE__*/__webpack_require__.n(google_login);
;// CONCATENATED MODULE: ./src/features/login/GoogleOauth/index.tsx












var googleClientId = "867806581579-u0ubjbmo7u3ikv05j099paceeirj6olm.apps.googleusercontent.com";
function GoogleOauth() {
    var loginMutation = (0,useLoginMutation/* useLoginGoogleMutation */.BT)();
    var errorHandler = hooks_useErrorHandler().errorHandler;
    var isLoading = (0,store/* useLoginState */.Ty)().isLoading;
    var ref = (0,store/* useLoginAction */.Hd)(), startLoading = ref.startLoading, setError = ref.setError;
    var handleCallback = {
        success: function(response) {
            if (!response) return;
            startLoading();
            var _profileObj = response.profileObj, email = _profileObj.email, fullname = _profileObj.name, googleId = response.googleId, tokenId = response.tokenId;
            var params = {
                accountId: googleId,
                accessToken: tokenId
            };
            loginMutation.mutate((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                resolveLoginErrorCallback: function() {
                    return errorHandler({
                        accountid: googleId,
                        accountkey: tokenId,
                        email: email,
                        fullname: fullname,
                        type: constants/* registerTypes.GOOGLE */.E8.GOOGLE
                    });
                }
            }));
        },
        error: function(err) {
            setError(err.error);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((google_login_default()), {
        clientId: googleClientId,
        buttonText: "Login",
        onSuccess: handleCallback.success,
        onFailure: handleCallback.error,
        cookiePolicy: "single_host_origin",
        className: "register-with-google-button hide",
        render: function(param) {
            var onClick = param.onClick;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                height: "44px",
                // @ts-expect-error
                mt: "10px",
                onClick: function() {
                    helpers/* sendClevertapEvent.loginMethod */.oq.loginMethod(constants/* registerTypes.GOOGLE */.E8.GOOGLE);
                    onClick();
                },
                block: true,
                loading: isLoading,
                id: "google-login-button",
                "data-cy": DATA_CY_LOGIN_COMPONENTS.LOGIN_FORM_BUTTON_GOOGLE,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthButton/* default */.Z, {
                    iconUrl: "/icon/register/icon-google.svg",
                    text: "Login with Google",
                    isFilled: true
                })
            });
        }
    });
}
/* harmony default export */ var login_GoogleOauth = (GoogleOauth);

// EXTERNAL MODULE: ./src/hooks/useMobileView.ts
var useMobileView = __webpack_require__(38833);
// EXTERNAL MODULE: ./src/lib/entities/credentials.js + 4 modules
var credentials = __webpack_require__(21671);
// EXTERNAL MODULE: ./src/utils/general.js
var general = __webpack_require__(42227);
// EXTERNAL MODULE: ./src/features/login/constants.ts
var login_constants = __webpack_require__(16727);
;// CONCATENATED MODULE: ./src/features/login/hooks/useRedirection.ts








function useLoginRedirection() {
    var dispatch = (0,es/* useDispatch */.I0)();
    var router = (0,next_router.useRouter)();
    var isLoggedIn = (0,es/* useSelector */.v9)(credentials/* selectors */.wl).isLoggedIn;
    var isLoading = (0,store/* useLoginState */.Ty)().isLoading;
    var stopLoading = (0,store/* useLoginAction */.Hd)().stopLoading;
    var isMobileView = (0,useMobileView/* default */.Z)().isMobileView;
    var ref = (0,react.useState)(false), authenticating = ref[0], setAuthenticating = ref[1];
    var ref1 = (0,react.useState)(false), navigating = ref1[0], setNavigating = ref1[1];
    (0,react.useEffect)(function() {
        setAuthenticating(isLoading);
    }, [
        isLoading
    ]);
    (0,react.useEffect)(function() {
        if (isLoggedIn && localStorage.getItem(login_constants/* LS_AUTH_KEY */.Ct)) {
            var ref, ref1;
            setNavigating(true);
            var redirectQueryParam = ((ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.redirect) === null || ref1 === void 0 ? void 0 : ref1.toString()) || "";
            var lsRedirectionTo = localStorage.getItem(login_constants/* LS_REDIRECTION_TO */.JO);
            var redirectUrl = redirectQueryParam || lsRedirectionTo || "/stream";
            var destination = decodeURIComponent(redirectUrl);
            router.push((0,general/* sanitizeURL */.lz)(destination));
            if (lsRedirectionTo) {
                localStorage.removeItem(login_constants/* LS_REDIRECTION_TO */.JO);
            }
        }
        var handleStopLoading = function() {
            setAuthenticating(false);
            stopLoading();
        };
        var handleRouteChangeStart = function() {
            handleStopLoading();
        };
        window.addEventListener("beforeunload", handleStopLoading);
        router_default().events.on("routeChangeStart", handleRouteChangeStart);
        return function() {
            setNavigating(false);
            router_default().events.off("routeChangeStart", handleRouteChangeStart);
        };
    }, [
        isLoggedIn,
        router,
        isMobileView,
        dispatch
    ]);
    return {
        authenticating: authenticating,
        navigating: navigating
    };
}
/* harmony default export */ var useRedirection = (useLoginRedirection);

;// CONCATENATED MODULE: ./src/features/login/index.tsx










function Login() {
    var ref = useRedirection(), authenticating = ref.authenticating, navigating = ref.navigating;
    var showLoginForm = !authenticating && !navigating;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QueryProvider/* default */.Z, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AuthCardLayout/* default */.Z, {
            withRegisterLink: showLoginForm,
            wrapperClassName: "login",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* LoginStyle */.U6, {}),
                showLoginForm ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(login_GoogleOauth, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(login_FacebookOauth, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {
                            label: "Or",
                            className: "form-divider"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(login_EmailLogin, {})
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(SecondarySpinner/* default */.Z, {
                    text: "Authenticating...",
                    style: {
                        height: "250px"
                    }
                })
            ]
        })
    });
}
/* harmony default export */ var login = (Login);


/***/ }),

/***/ 8340:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Hd": function() { return /* binding */ useLoginAction; },
/* harmony export */   "Ty": function() { return /* binding */ useLoginState; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14671);
/* harmony import */ var immer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12902);




var initialState = {
    emailLoginProps: {
        username: "",
        password: ""
    },
    isLoading: false,
    error: null,
    message: ""
};
var useStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(function(set) {
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, initialState), {
        actions: {
            setEmailLoginProps: function(param) {
                var username = param.username, password = param.password;
                set((0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(state) {
                    state.emailLoginProps.username = username;
                    state.emailLoginProps.password = password;
                }));
            },
            startLoading: function() {
                set((0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(state) {
                    state.isLoading = true;
                }));
            },
            stopLoading: function() {
                set((0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(state) {
                    state.isLoading = false;
                }));
            },
            setError: function(error) {
                set((0,immer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(function(state) {
                    state.error = error;
                    state.message = error;
                }));
            }
        }
    });
});
var useLoginAction = function() {
    return useStore(function(state) {
        return state.actions;
    });
};
var useLoginState = function() {
    return useStore(function(state) {
        return state;
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (useStore)));


/***/ }),

/***/ 30928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "U6": function() { return /* binding */ LoginStyle; },
/* harmony export */   "fK": function() { return /* binding */ EmailContainer; },
/* harmony export */   "fv": function() { return /* binding */ InputContainer; },
/* harmony export */   "on": function() { return /* binding */ PasswordContainer; }
/* harmony export */ });
/* unused harmony exports Wrapper, DividerContainer, Center, ImgIcon */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_IconBase64__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37949);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_common_InputForm__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23906);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-sizing: border-box;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  box-shadow: ",
        " 0px 0px 10px;\n  margin: auto;\n\n  @media ",
        " {\n    width: 100%;\n    padding: 20px 40px;\n  }\n\n  @media ",
        " {\n    width: 450px;\n    padding: 40px 70px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  width: 100% !important;\n  font-family: 'ProximaNovaLt';\n\n  &#username {\n    width: 100%;\n  }\n\n  &#password {\n    width: calc(100% - 28px) !important;\n  }\n\n  input {\n    &::placeholder {\n      font-family: 'ProximaNovaLt';\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  label {\n    font-family: 'ProximaNovaLt';\n  }\n\n  button {\n    background: transparent;\n    border: none;\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    cursor: pointer;\n  }\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n\n  img {\n    width: 18px;\n    height: 18px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 1px;\n  margin: 10px 0;\n  background-color: ",
        ";\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 0 20px;\n  background-color: ",
        ";\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border-radius: 0;\n  width: 14px;\n  height: 14px;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  label {\n    font-family: 'ProximaNovaLt';\n  }\n\n  input {\n    color: ",
        ";\n    font-size: 18px;\n  }\n\n  input:not(:placeholder-shown) ~ label,\n  input:focus ~ label {\n    font-family: 'ProximaNovaBd';\n    font-size: 12px !important;\n    top: -24px !important;\n    color: ",
        ";\n  }\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .login,\n  .register {\n    border: none;\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n\n    button.ant-btn {\n      border-radius: 4px;\n      padding: 5px 16px;\n    }\n\n    button.ant-btn-facebook {\n      background: #33579D;\n    }\n\n    button.btn-successful-register {\n      border-radius: 4px;\n    }\n\n    button.ant-btn-default {\n      border: 1px solid ",
        ";\n    }\n\n    button.ant-btn .ant-btn-loading-icon {\n      display: flex;\n    }\n\n    button:disabled, button:disabled:hover {\n      background-color: #8CD9BC !important;\n      border-color: #8CD9BC !important;\n\n      p {\n        color: ",
        " !important;\n      }\n    }\n\n    .form-divider {\n      margin: 10px 20px;\n      width: auto;\n      \n      p {\n        font-family: ProximaNovaLt;\n      }\n    }\n\n    @media ",
        " {\n      padding: 28px 30px !important;\n      width: 100% !important;\n    }\n\n    @media ",
        " {\n      padding: 32px 40px !important;\n      width: 450px !important;\n    }\n  }\n\n  .auth-text-container {\n    padding: 0;\n  }\n\n  .ant-message-notice.sysmsg-content {\n    max-width: 440px !important;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}






var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2ef7525a-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mobileS */ .Z.mobileS, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mobileL */ .Z.mobileL);
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    p: "0"
}).withConfig({
    componentId: "sc-2ef7525a-1"
})(_templateObject1());
var PasswordContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2ef7525a-2"
})(_templateObject2());
var EmailContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(PasswordContainer).withConfig({
    componentId: "sc-2ef7525a-3"
})(_templateObject3(), function(param) {
    var _showIcon = param.showIcon, showIcon = _showIcon === void 0 ? false : _showIcon;
    return showIcon && "\n    ".concat(Input, " {\n      width: calc(100% - 28px) !important;\n    }\n  ");
});
var DividerContainer = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2ef7525a-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].gainsboro */ .Z.gainsboro);
var Center = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-2ef7525a-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light);
var ImgIcon = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_IconBase64__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2ef7525a-6"
})(_templateObject6());
var InputContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_InputForm__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-2ef7525a-7"
})(_templateObject7(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].highempahis */ .Z.highempahis, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].highempahis */ .Z.highempahis);
var LoginStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* .createGlobalStyle */ .vJ)(_templateObject8(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mobileS */ .Z.mobileS, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mobileL */ .Z.mobileL);



/***/ }),

/***/ 73442:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ AuthButtonView; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(89213);





function AuthButtonView(param) {
    var iconUrl = param.iconUrl, text = param.text, _isFilled = param.isFilled, isFilled = _isFilled === void 0 ? false : _isFilled;
    var textColor = isFilled ? _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].black */ .Z.black : _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].light */ .Z.light;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .ButtonContainer */ .qO, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .ButtonIcon */ .Ei, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    src: iconUrl,
                    width: 24,
                    height: 24
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                color: textColor,
                size: "14px",
                family: "bold",
                children: text
            })
        ]
    });
};


/***/ }),

/***/ 89213:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BH": function() { return /* binding */ RegisterStyle; },
/* harmony export */   "Ei": function() { return /* binding */ ButtonIcon; },
/* harmony export */   "II": function() { return /* binding */ Input; },
/* harmony export */   "KM": function() { return /* binding */ InputPinContainer; },
/* harmony export */   "Pk": function() { return /* binding */ InputPhoneContainer; },
/* harmony export */   "Tc": function() { return /* binding */ InputPinWrapper; },
/* harmony export */   "cW": function() { return /* binding */ CustomStyle; },
/* harmony export */   "qO": function() { return /* binding */ ButtonContainer; }
/* harmony export */ });
/* unused harmony exports InputContainer, InputNumber, Spacer, TextInfo, Wrapper */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  box-sizing: border-box;\n  background-color: ",
        ";\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n  box-shadow: 0 0 10px ",
        ";\n\n  @media ",
        " {\n    width: 100%;\n    padding: 20px 40px;\n  }\n\n  @media ",
        " {\n    width: 450px;\n    padding: 40px 70px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n\n  .phone-dropdown-button {\n    background-color: transparent !important;\n    border: none;\n\n    div {\n      border: none;\n    }\n\n    .arrow {\n      left: 24px;\n      border-left: 4px solid transparent;\n      border-right: 4px solid transparent;\n      border-top: 5px solid #555;\n    }\n  }\n\n  .phone-input {\n    font-size: 15px !important;\n    line-height: 19px;\n    font-weight: 700 !important;\n    color: #333333 !important;\n  }\n\n  .phone-input::placeholder {\n    font-weight: 400 !important;\n  }\n\n  button {\n    background: transparent;\n    border: none;\n    position: absolute;\n    right: 0;\n    top: 20%;\n    cursor: pointer;\n  }\n\n  img {\n    width: 16px;\n    height: 16px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n  padding: 0;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 30px;\n  margin-right: 10px;\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: none;\n  border-bottom: 1px solid ",
        ";\n  width: 45px;\n  font-size: 22px;\n  font-weight: bold;\n  text-align: center;\n  padding: 0;\n\n  :focus,\n  :hover {\n    border-bottom: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 12px;\n  color: ",
        ";\n  text-align: center;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  /* Hide google recaptcha */\n    .grecaptcha-badge {\n      opacity: 1;\n      visibility: visible;\n    }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n      height: ",
        "px;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  gap: 50px;\n  align-self: stretch;\n  width: 100%;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin-top: -20px;\n"
    ]);
    _templateObject11 = function _templateObject11() {
        return data;
    };
    return data;
}
function _templateObject12() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  .register,\n  .login {\n    display: flex;\n    flex-direction: column;\n    gap: 24px;\n    border: none;\n\n    button.ant-btn {\n      border-radius: 4px;\n      padding: 5px 16px;\n    }\n\n    button.ant-btn-facebook {\n      background: #33579D;\n    }\n\n    button.btn-successful-register {\n      border-radius: 4px;\n    }\n\n    button.ant-btn-default {\n      border: 1px solid ",
        ";\n    }\n\n    button.ant-btn .ant-btn-loading-icon {\n      display: flex;\n    }\n\n    button:disabled, button:disabled:hover {\n      background-color: #8CD9BC !important;\n      border-color: #8CD9BC !important;\n\n      p {\n        color: ",
        " !important;\n      }\n    }\n\n    .form-divider {\n      margin: 10px 20px;\n      width: auto;\n      \n      p {\n        font-family: ProximaNovaLt;\n      }\n    }\n\n    @media ",
        " {\n      width: 100% !important;\n      padding: 28px 30px !important;\n    }\n\n    @media ",
        " {\n      width: 450px !important;\n      padding: 32px 40px !important;\n    }\n  }\n\n  .auth-text-container {\n    padding: 0;\n  }\n\n  .ant-message-notice.sysmsg-content {\n    max-width: 440px !important;\n  }\n\n  @media ",
        " {\n    .ant-tooltip-placement-leftTop {\n      display: none;\n    }\n\n    .ant-tooltip-hidden {\n      display: none !important;\n    }\n  }\n\n  @media ",
        " {\n    .ant-tooltip-placement-leftTop {\n      display: block;\n    }\n\n    .ant-tooltip-hidden {\n      display: none !important;\n    }\n  }\n"
    ]);
    _templateObject12 = function _templateObject12() {
        return data;
    };
    return data;
}
function _templateObject13() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n  margin: 24px 0 20px;\n\n  input {\n    border: none;\n    border-bottom: 1px solid ",
        ";\n    width: 35px;\n    height: 40px;\n    font-size: 24px;\n    font-weight: bold;\n    text-align: center;\n    outline: none;\n  }\n\n  input:focus,\n  input.filled {\n    border-color: ",
        ";\n  }\n"
    ]);
    _templateObject13 = function _templateObject13() {
        return data;
    };
    return data;
}





var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].lowgray */ .Z.lowgray, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileS */ .Z.mobileS, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].tablet */ .Z.tablet);
var InputPhoneContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-1"
})(_templateObject1());
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8b53bd67-2"
})(_templateObject2());
var InputContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-3"
})(_templateObject3());
var InputNumber = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8b53bd67-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);
var TextInfo = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8b53bd67-5"
})(_templateObject5(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].dimGray */ .Z.dimGray);
var CustomStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .createGlobalStyle */ .vJ)(_templateObject6());
var Spacer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-6"
})(_templateObject8(), function(param) {
    var height = param.height;
    return height && (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .css */ .iv)(_templateObject7(), height);
});
var ButtonContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-7"
})(_templateObject9());
var ButtonIcon = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-8"
})(_templateObject10());
var InputPinContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-9"
})(_templateObject11());
var RegisterStyle = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* .createGlobalStyle */ .vJ)(_templateObject12(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].downgray */ .Z.downgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].light */ .Z.light, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileS */ .Z.mobileS, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileL */ .Z.mobileL, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].mobileS */ .Z.mobileS, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_3__/* ["default"].laptop */ .Z.laptop);
var InputPinWrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8b53bd67-10"
})(_templateObject13(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].highgray */ .Z.highgray, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_4__/* ["default"].primary */ .Z.primary);



/***/ }),

/***/ 27253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22147);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28896);




function Divider(param) {
    var _className = param.className, className = _className === void 0 ? "" : _className, label = param.label;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .DividerContainer */ .kP, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_3__/* .Center */ .M5, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                align: "center",
                color: _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_2__/* ["default"].midgray */ .Z.midgray,
                children: label
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Divider);


/***/ }),

/***/ 33406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ global_AuthCardLayout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/global/ErrorHandlers/If.js
var If = __webpack_require__(29658);
// EXTERNAL MODULE: ./src/global/Image/index.js
var Image = __webpack_require__(579);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Avatar.js
var Avatar = __webpack_require__(57788);
;// CONCATENATED MODULE: ./src/global/AuthCardLayout/StockbitLogo.tsx






var logo = "/images/logokotak.svg";
function StockbitLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        justify: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Avatar/* default */.Z, {
                size: "large",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                    alt: "Stockbit",
                    "data-cy": "stockbit-logo",
                    src: logo,
                    style: {
                        background: color/* default.highempahis */.Z.highempahis,
                        border: "none"
                    },
                    className: "stockbit-logo"
                })
            })
        })
    });
}
/* harmony default export */ var AuthCardLayout_StockbitLogo = (StockbitLogo);

// EXTERNAL MODULE: ./src/global/AuthCardLayout/styled.ts
var styled = __webpack_require__(28896);
;// CONCATENATED MODULE: ./src/global/AuthCardLayout/index.tsx










function AuthCardLayout(param) {
    var children = param.children, _hasShadow = param.hasShadow, hasShadow = _hasShadow === void 0 ? true : _hasShadow, _withBackIcon = param.withBackIcon, withBackIcon = _withBackIcon === void 0 ? false : _withBackIcon, _withLoginLink = param.withLoginLink, withLoginLink = _withLoginLink === void 0 ? false : _withLoginLink, _withLogo = param.withLogo, withLogo = _withLogo === void 0 ? true : _withLogo, _withRegisterLink = param.withRegisterLink, withRegisterLink = _withRegisterLink === void 0 ? false : _withRegisterLink, _withTermsLink = param.withTermsLink, withTermsLink = _withTermsLink === void 0 ? false : _withTermsLink, _wrapperClassName = param.wrapperClassName, wrapperClassName = _wrapperClassName === void 0 ? "" : _wrapperClassName, _backAction = param.backAction, backAction = _backAction === void 0 ? null : _backAction;
    var router = (0,next_router.useRouter)();
    var handleBackClick = function() {
        if (backAction) {
            backAction();
        } else {
            router.push("/");
        }
    };
    var showFooter = withLoginLink || withTermsLink || withRegisterLink;
    var shadowClass = hasShadow ? "shadowed" : "";
    var wrapperClass = wrapperClassName || "";
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* Wrapper */.im, {
        className: "".concat(shadowClass, " ").concat(wrapperClass),
        "data-cy": "auth-card-layout",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: withLogo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    justify: withBackIcon ? "space-between" : "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: withBackIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                className: "login-back-icon",
                                onClick: handleBackClick,
                                type: "button",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                                    src: "/icon/chevron-left-gray.svg",
                                    width: "10px",
                                    height: "18px"
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AuthCardLayout_StockbitLogo, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: withBackIcon,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                        })
                    ]
                })
            }),
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                condition: showFooter,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    align: "center",
                    className: "auth-text-container",
                    direction: "column",
                    justify: "center",
                    // @ts-expect-error
                    pt: "20px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: withLoginLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TextInfo */.DR, {
                                children: [
                                    "Already have a Stockbit account?",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/login",
                                        "data-cy": "auth-card-login-link",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            as: "a",
                                            size: "12px",
                                            children: "Login"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: withTermsLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* TextInfo */.DR, {
                                size: "12px",
                                children: [
                                    "By signing up you agree with our",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/terms",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            as: "a",
                                            size: "12px",
                                            "data-cy": "auth-card-terms-link",
                                            children: "Terms & Conditions."
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(If/* default */.Z, {
                            condition: withRegisterLink,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                align: "center",
                                color: color/* default.black */.Z.black,
                                size: "12px",
                                children: [
                                    "New to Stockbit?",
                                    " ",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: "/register",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                            as: "a",
                                            size: "12px",
                                            "data-cy": "auth-card-register-link",
                                            children: "Sign Up"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var global_AuthCardLayout = (AuthCardLayout);


/***/ }),

/***/ 28896:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DR": function() { return /* binding */ TextInfo; },
/* harmony export */   "M5": function() { return /* binding */ Center; },
/* harmony export */   "im": function() { return /* binding */ Wrapper; },
/* harmony export */   "kP": function() { return /* binding */ DividerContainer; }
/* harmony export */ });
/* unused harmony export Input */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54325);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22147);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74575);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  border-radius: 4px;\n  border: 1px solid ",
        ";\n  box-sizing: border-box;\n  margin: auto;\n\n  &.shadowed {\n    box-shadow: ",
        " 0px 0px 10px;\n  }\n\n  @media ",
        " {\n    padding: 20px 40px;\n    width: 100%;\n  }\n\n  @media ",
        " {\n    padding: 40px 70px;\n    width: 450px;\n  }\n\n  input[type='tel'] {\n    height: 36px !important;\n  }\n\n  button.login-back-icon {\n    background: transparent;\n    border: none;\n    cursor: pointer;\n  }\n\n  img.stockbit-logo {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  font-size: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  align-items: center;\n  background-color: ",
        ";\n  display: flex;\n  height: 1px;\n  justify-content: center;\n  margin: 29px 0;\n  width: 100%;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background-color: ",
        ";\n  padding: 0 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  font-size: 12px;\n  text-align: center;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}





var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ec4fe886-0"
})(_templateObject(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mobileS */ .Z.mobileS, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].mobileL */ .Z.mobileL);
var Input = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Input__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).attrs({
    p: "0"
}).withConfig({
    componentId: "sc-ec4fe886-1"
})(_templateObject1());
var DividerContainer = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ec4fe886-2"
})(_templateObject2(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].gainsboro */ .Z.gainsboro);
var Center = styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-ec4fe886-3"
})(_templateObject3(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].light */ .Z.light);
var TextInfo = (0,styled_components__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-ec4fe886-4"
})(_templateObject4(), _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_3__/* ["default"].black */ .Z.black);



/***/ }),

/***/ 29658:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

var If = function(param) {
    var children = param.children, condition = param.condition;
    if (!condition) {
        return null;
    }
    // render children if the condition is truthy
    return children;
};
/* harmony default export */ __webpack_exports__["Z"] = (If); /**
 * https://www.stefanjudis.com/snippets/a-react-if-component/
 *
 * Use the component as follows:
 *
 * <IF condition={condition}>
 *   <Greeter username={user.name} />
 * </IF>
 */ 


/***/ }),

/***/ 32447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95541);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(29658);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  @keyframes rotate {\n    0% {\n      transform: rotate(0deg);\n      opacity: 1;\n    }\n    50% {\n      opacity: 0.8;\n    }\n    100% {\n      transform: rotate(360deg);\n      opacity: 1;\n    }\n  }\n\n  > div {\n    display: block;\n    margin: auto;\n    height: ",
        ";\n    width: ",
        ";\n    animation: rotate 0.8s infinite linear;\n    border-radius: 50%;\n    border: solid 1.5px ",
        ";\n    border-right-color: transparent;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





// eslint-disable-next-line space-infix-ops
var SecondarySpinnerDiv = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bfa5182-0"
})(_templateObject(), function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.size) || "18px";
}, function(props) {
    return (props === null || props === void 0 ? void 0 : props.color) || "#6b6b6b";
});
var SecondarySpinner = function(_param) /*#__PURE__*/ {
    var _size = _param.size, size = _size === void 0 ? "18px" : _size, text = _param.text, _color = _param.color, color = _color === void 0 ? "#6b6b6b" : _color, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "size",
        "text",
        "color",
        "isLoading"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        condition: isLoading,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
            direction: "column",
            justify: "center",
            align: "center"
        }, props), {
            "data-cy": "global-loading-spinner-container",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SecondarySpinnerDiv, {
                    size: size,
                    color: color,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {})
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    condition: text,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        family: "light",
                        padding: "20px 0 0 0",
                        children: text
                    })
                })
            ]
        }))
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SecondarySpinner);


/***/ }),

/***/ 62780:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51767);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85945);


var queryClient = new _tanstack_react_query__WEBPACK_IMPORTED_MODULE_1__/* .QueryClient */ .S({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false
        }
    }
});
var QueryProvider = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__/* .QueryClientProvider */ .aH, {
        client: queryClient,
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (QueryProvider);


/***/ }),

/***/ 38833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

function useMobileView() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isMobileView = ref[0], setIsMobileView = ref[1];
    var checkWindowWidth = function() {
        var timeoutId = null;
        clearTimeout(timeoutId);
        timeoutId = setTimeout(function() {
            var ref = (document === null || document === void 0 ? void 0 : document.documentElement) || {}, width = ref.clientWidth;
            if (width < 768) {
                setIsMobileView(true);
            } else {
                setIsMobileView(false);
            }
        }, 16);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        window.addEventListener("resize", checkWindowWidth);
        checkWindowWidth();
        return function() {
            window.removeEventListener("resize", checkWindowWidth);
        };
    }, []);
    return {
        isMobileView: isMobileView
    };
}
/* harmony default export */ __webpack_exports__["Z"] = (useMobileView);


/***/ }),

/***/ 48228:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "D": function() { return /* binding */ useMutation; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/useSyncExternalStore.mjs
var useSyncExternalStore = __webpack_require__(464);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/utils.mjs
var utils = __webpack_require__(32161);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/mutation.mjs
var mutation = __webpack_require__(89886);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
var notifyManager = __webpack_require__(30081);
// EXTERNAL MODULE: ./node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var subscribable = __webpack_require__(33989);
;// CONCATENATED MODULE: ./node_modules/@tanstack/query-core/build/lib/mutationObserver.mjs





// CLASS
class MutationObserver extends subscribable/* Subscribable */.l {
  constructor(client, options) {
    super();
    this.client = client;
    this.setOptions(options);
    this.bindMethods();
    this.updateResult();
  }

  bindMethods() {
    this.mutate = this.mutate.bind(this);
    this.reset = this.reset.bind(this);
  }

  setOptions(options) {
    var _this$currentMutation;

    const prevOptions = this.options;
    this.options = this.client.defaultMutationOptions(options);

    if (!(0,utils/* shallowEqualObjects */.VS)(prevOptions, this.options)) {
      this.client.getMutationCache().notify({
        type: 'observerOptionsUpdated',
        mutation: this.currentMutation,
        observer: this
      });
    }

    (_this$currentMutation = this.currentMutation) == null ? void 0 : _this$currentMutation.setOptions(this.options);
  }

  onUnsubscribe() {
    if (!this.listeners.length) {
      var _this$currentMutation2;

      (_this$currentMutation2 = this.currentMutation) == null ? void 0 : _this$currentMutation2.removeObserver(this);
    }
  }

  onMutationUpdate(action) {
    this.updateResult(); // Determine which callbacks to trigger

    const notifyOptions = {
      listeners: true
    };

    if (action.type === 'success') {
      notifyOptions.onSuccess = true;
    } else if (action.type === 'error') {
      notifyOptions.onError = true;
    }

    this.notify(notifyOptions);
  }

  getCurrentResult() {
    return this.currentResult;
  }

  reset() {
    this.currentMutation = undefined;
    this.updateResult();
    this.notify({
      listeners: true
    });
  }

  mutate(variables, options) {
    this.mutateOptions = options;

    if (this.currentMutation) {
      this.currentMutation.removeObserver(this);
    }

    this.currentMutation = this.client.getMutationCache().build(this.client, { ...this.options,
      variables: typeof variables !== 'undefined' ? variables : this.options.variables
    });
    this.currentMutation.addObserver(this);
    return this.currentMutation.execute();
  }

  updateResult() {
    const state = this.currentMutation ? this.currentMutation.state : (0,mutation/* getDefaultState */.R)();
    const result = { ...state,
      isLoading: state.status === 'loading',
      isSuccess: state.status === 'success',
      isError: state.status === 'error',
      isIdle: state.status === 'idle',
      mutate: this.mutate,
      reset: this.reset
    };
    this.currentResult = result;
  }

  notify(options) {
    notifyManager/* notifyManager.batch */.V.batch(() => {
      // First trigger the mutate callbacks
      if (this.mutateOptions && this.hasListeners()) {
        if (options.onSuccess) {
          var _this$mutateOptions$o, _this$mutateOptions, _this$mutateOptions$o2, _this$mutateOptions2;

          (_this$mutateOptions$o = (_this$mutateOptions = this.mutateOptions).onSuccess) == null ? void 0 : _this$mutateOptions$o.call(_this$mutateOptions, this.currentResult.data, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o2 = (_this$mutateOptions2 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o2.call(_this$mutateOptions2, this.currentResult.data, null, this.currentResult.variables, this.currentResult.context);
        } else if (options.onError) {
          var _this$mutateOptions$o3, _this$mutateOptions3, _this$mutateOptions$o4, _this$mutateOptions4;

          (_this$mutateOptions$o3 = (_this$mutateOptions3 = this.mutateOptions).onError) == null ? void 0 : _this$mutateOptions$o3.call(_this$mutateOptions3, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
          (_this$mutateOptions$o4 = (_this$mutateOptions4 = this.mutateOptions).onSettled) == null ? void 0 : _this$mutateOptions$o4.call(_this$mutateOptions4, undefined, this.currentResult.error, this.currentResult.variables, this.currentResult.context);
        }
      } // Then trigger the listeners


      if (options.listeners) {
        this.listeners.forEach(listener => {
          listener(this.currentResult);
        });
      }
    });
  }

}


//# sourceMappingURL=mutationObserver.mjs.map

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/QueryClientProvider.mjs
var QueryClientProvider = __webpack_require__(85945);
// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/lib/utils.mjs
var lib_utils = __webpack_require__(24798);
;// CONCATENATED MODULE: ./node_modules/@tanstack/react-query/build/lib/useMutation.mjs
'use client';






function useMutation(arg1, arg2, arg3) {
  const options = (0,utils/* parseMutationArgs */.lV)(arg1, arg2, arg3);
  const queryClient = (0,QueryClientProvider/* useQueryClient */.NL)({
    context: options.context
  });
  const [observer] = react.useState(() => new MutationObserver(queryClient, options));
  react.useEffect(() => {
    observer.setOptions(options);
  }, [observer, options]);
  const result = (0,useSyncExternalStore/* useSyncExternalStore */.$)(react.useCallback(onStoreChange => observer.subscribe(notifyManager/* notifyManager.batchCalls */.V.batchCalls(onStoreChange)), [observer]), () => observer.getCurrentResult(), () => observer.getCurrentResult());
  const mutate = react.useCallback((variables, mutateOptions) => {
    observer.mutate(variables, mutateOptions).catch(noop);
  }, [observer]);

  if (result.error && (0,lib_utils/* shouldThrowError */.L)(observer.options.useErrorBoundary, [result.error])) {
    throw result.error;
  }

  return { ...result,
    mutate,
    mutateAsync: result.mutate
  };
} // eslint-disable-next-line @typescript-eslint/no-empty-function

function noop() {}


//# sourceMappingURL=useMutation.mjs.map


/***/ }),

/***/ 464:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useSyncExternalStore; }
/* harmony export */ });
/* harmony import */ var use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(61688);
'use client';


const useSyncExternalStore = use_sync_external_store_shim_index_js__WEBPACK_IMPORTED_MODULE_0__.useSyncExternalStore;


//# sourceMappingURL=useSyncExternalStore.mjs.map


/***/ }),

/***/ 24798:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "L": function() { return /* binding */ shouldThrowError; }
/* harmony export */ });
function shouldThrowError(_useErrorBoundary, params) {
  // Allow useErrorBoundary function to override throwing behavior on a per-error basis
  if (typeof _useErrorBoundary === 'function') {
    return _useErrorBoundary(...params);
  }

  return !!_useErrorBoundary;
}


//# sourceMappingURL=utils.mjs.map


/***/ })

}]);